import { createFileRoute } from '@tanstack/react-router';
import { DeliveryImportPage } from '@features/admin/delivery-import';

export const Route = createFileRoute('/admin/delivery-import/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DeliveryImportPage />;
}
